import { on } from '@ngrx/store';

import { createImmutableReducer } from '../../base/store/helpers';
import BetslipPickActions from '../picks/actions';
import { addGroup, replaceGroup } from '../picks/grouped-picks.actions';
import { pickSelectionHandlers } from '../picks/reducer';
import { removeTypePicks } from '../picks/services/type-pick.utils';
import BetslipComboBetActions from './actions';
import { IComboBetPickState, IComboBetState, defaultComboBetState } from './state';

export const comboBetReducer = createImmutableReducer(
    defaultComboBetState,
    ...pickSelectionHandlers<IComboBetState>(),
    on(BetslipComboBetActions.addPick, (state, action) => {
        state.picks[action.pickId] = {
            ...getDefaultPickState(),
            ...action.pickState,
        };

        return state;
    }),
    on(BetslipComboBetActions.removePick, (state, action) => {
        delete state.picks[action.pickId];

        return state;
    }),
    on(BetslipComboBetActions.replacePick, (state, action) => {
        state.picks[action.newPickId] = { ...state.picks[action.oldPIckId] };
        delete state.picks[action.oldPIckId];

        return state;
    }),

    on(BetslipComboBetActions.setComboBetStake, (state, action) => {
        state.stake = action.stake;
        state.actualStake = action.stakeStr ? action.stakeStr : (action.stake?.toString() ?? null);

        return state;
    }),
    on(BetslipComboBetActions.setComboEachWay, (state, action) => {
        state.isEachWay = action.isEachWay;

        return state;
    }),
    on(BetslipComboBetActions.setComboBetRewardToken, (state, action) => {
        state.rewardTokenId = action.rewardTokenId;

        return state;
    }),
    on(BetslipComboBetActions.toggleComboBetPick, (state, action) => {
        const pickId = action.pickId.toString();
        if (!state.picks[pickId]) {
            return state;
        }
        state.picks[pickId].isSelected = !state.picks[pickId].isSelected;

        return state;
    }),
    on(replaceGroup, addGroup, (state, action) => {
        const groupPickId = action.newPick.id.toString();

        if (!state.picks[groupPickId]) {
            state.picks[groupPickId] = getDefaultPickState();
        }

        action.newPick.getLegs().forEach((pick) => {
            delete state.picks[pick.id.toString()];
        });

        return state;
    }),
    on(BetslipPickActions.removeTypePicks, (state, action) => {
        removeTypePicks(action.pickIds, state.picks);

        return state;
    }),
);

function getDefaultPickState(): IComboBetPickState {
    return {
        isSelected: true,
        isLocked: false,
    };
}
